import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import GalleryViewerPage from './GalleryViewerPage';

const GalleryViewerPageWrapper = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Extract albums data from navigation params (similar to reference project)
  const albums = location.state?.albums || [];
  const initialPage = location.state?.key || 0;
  const params = useParams();
  const { goalId } = params;

  return (
    <GalleryViewerPage 
      navigate={navigate}
      location={location}
      albums={albums}
      initialPage={initialPage}
      goalId={goalId}
    />
  );
};

export default GalleryViewerPageWrapper;
